/**
 * Default: Modules > News > Slider
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import {extend} from '../../../shared/utils/index';
import {
	isElement,
	isString
}               from '../../../shared/utils/is';

import SelectorEngine from '../../../shared/dom/selector-engine';
import Data           from '../../../shared/dom/data';
import Slider         from '../../../shared/components/slider';

// -------
// Private
// -------

const NAME      = 'news-slider';
const DATA_KEY  = `ifab.${NAME}`;
// const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY   = `.data-api`;

// const DEFAULTS = {};

const render = (element) => {
	// Wurde Element schon initialisiert?
	if (Data.get(element, `${DATA_KEY}.initialized`)) {
		return element;
	}

	//
	// Slider
	//

	const slider = SelectorEngine.findOne(`[data-c="slider-${NAME}"]`, element);

	if (slider) {
		Slider.init(element, {
			slidesPerView: 'auto',
			spaceBetween: 0,
			autoHeight: false
		});
	}

	// Initialisierungsstatus setzen.
	Data.set(element, `${DATA_KEY}.initialized`, true);

	return element;
};

// -------
// Public
// -------

/**
 * ´News Slider´-Elemente finden und initialisieren.
 */
const init = () => {
	const collection = SelectorEngine.find(`.${NAME}`);

	for (const element of collection) {
		render(element);
	}
};

// Execute
init();
